import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./PAGES/ACTIONS/login/Login";
import AddDisputes from "./PAGES/DISPUTES/addDisputes/AddDisputes";
import ClosedDisputes from "./PAGES/DISPUTES/closedDisputes/ClosedDisputes";
import ActiveDisputes from "./PAGES/DISPUTES/activeDisputes/ActiveDisputes";
import Home from "./PAGES/HOME/Home";
import AddSubscriber from "./PAGES/SUBSCRIBERS/addSubscriber/AddSubscriber";
import AddUser from "./PAGES/SUBSCRIBERS/addUser/AddUser";
import ListofStaffs from "./PAGES/SUBSCRIBERS/listofStaffs/ListofStaffs";
import ListofSubscribers from "./PAGES/SUBSCRIBERS/listofSubscribers/ListofSubscribers";
import ListofUsers from "./PAGES/SUBSCRIBERS/listofUsers/ListofUsers";
import ViewClosedDispute from "./PAGES/DISPUTES/closedDisputes/ViewClosedDispute";
import ViewActiveDispute from "./PAGES/DISPUTES/activeDisputes/ViewActiveDispute";
import ViewSubscriberDetails from "./PAGES/SUBSCRIBERS/listofSubscribers/ViewSubscriberDetails";
import ResetPassword from "./PAGES/SUBSCRIBERS/resetPassword/ResetPassword";
import ViewStaffDetails from "./PAGES/SUBSCRIBERS/listofStaffs/ViewStaffDetails";
import ViewUserDetails from "./PAGES/SUBSCRIBERS/listofUsers/ViewUserDetails";
import AddNonUpdatedContracts from "./PAGES/NON UPDATED CONTRACTS/addNonUpdatedContracts/AddNonUpdatedContracts";
import NonUpdatedContracts from "./PAGES/NON UPDATED CONTRACTS/nonUpdatedContracts/NonUpdatedContracts";
import AuthContext from "./CONTEXT/AuthProvider";
import { useContext } from "react";
import SearchedDisputes from "./PAGES/DISPUTES/closedDisputes/AssessClosedDisputes";
import GraphicAnalysis from "./PAGES/DISPUTES/graphicAnalysis/GraphicAnalysis";
import ViewNonUpdatedContract from "./PAGES/NON UPDATED CONTRACTS/nonUpdatedContracts/ViewNonUpdatedContract";
import DeletionForm from "./PAGES/DELETION/Add Delition/DeletionForm";
import DeletionRequests from "./PAGES/DELETION/Deletion Requests/DeletionRequests";
import ViewDeletionRequest from "./PAGES/DELETION/Deletion Requests/ViewDeletionRequest";
import SearchHistory from "./PAGES/NAME LOOKUP/searchHistory/SearchHistory";
import Search from "./PAGES/NAME LOOKUP/searchNumber/Search";
import AssessReport from "./PAGES/NAME LOOKUP/assessReport/AssessReport";
import Logs from "./PAGES/LOGS/Logs";
import MFISurveyForm from "./pages/MFI SURVEY/MFISurveyForm";
import SuccessMessage from "./pages/MFI SURVEY/SuccessMessage";

function App() {
  const { auth } = useContext(AuthContext);

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={auth.status === "Approved" ? <Home /> : <Login />}
          />
          <Route
            path="/login"
            element={
              auth.status === "Approved" ? <Navigate to="/" /> : <Login />
            }
          />
          <Route
            path="/addSubscriber"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <AddSubscriber />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/listofSubscribers"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <ListofSubscribers />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/addUser"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <AddUser />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/listofUsers"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <ListofUsers />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/listofStaffs"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <ListofStaffs />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/loghistory"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <Logs />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/addDisputes"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <AddDisputes />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/activeDisputes"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <ActiveDisputes />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/closedDisputes"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <ClosedDisputes />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/addNonUpdatedContracts"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <AddNonUpdatedContracts />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/nonUpdatedContracts"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <NonUpdatedContracts />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/ViewNonUpdatedContract"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <ViewNonUpdatedContract />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/deletionForm"
            element={
              auth.status === "Approved" && auth.role === "compliance" ? (
                <DeletionForm />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/deletionRequests"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <DeletionRequests />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/ViewDeletionRequestDetails"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <ViewDeletionRequest />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/searchedDisputes"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <SearchedDisputes />
              ) : (
                <Login />
              )
            }
          />
          {/* <Route path="/graphicAnalysis" element={<GraphicAnalysis />} />
           */}
          <Route
            path="/ViewClosedDisputes"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <ViewClosedDispute />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/ViewActiveDisputes"
            element={
              auth.status === "Approved" && auth.disputeManagement === "1" ? (
                <ViewActiveDispute />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/ViewSubscriberDetails"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <ViewSubscriberDetails />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/resetPassword"
            element={auth.status === "Approved" ? <ResetPassword /> : <Login />}
          />
          <Route
            path="/staffDetails"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <ViewStaffDetails />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/userDetails"
            element={
              auth.status === "Approved" && auth.role === "admin" ? (
                <ViewUserDetails />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/search-History"
            element={
              auth.status === "Approved" && auth.nameLookup === "1" ? (
                <SearchHistory />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/new-search"
            element={
              auth.status === "Approved" && auth.nameLookup === "1" ? (
                <Search />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/assess-report"
            element={
              auth.status === "Approved" && auth.nameLookup === "1" ? (
                <AssessReport />
              ) : (
                <Login />
              )
            }
          />
          <Route path="/MFISurveyForm" element={<MFISurveyForm />} />
          <Route path="/success-message" element={<SuccessMessage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
